exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trigger-event-hover .on-event-hover {\n  display: none;\n}\n.trigger-event-hover:hover .on-event-hover {\n  display: flex;\n}\n", ""]);

// exports
